<!-- start all funds section -->
<section class="FT-all-funds" [ngClass]="{'FT-navs-funds': componentType !== 'PPSS'}">
  <div class="container" *ngIf="isLoaded else loaderBlock">
    <ng-container *ngIf="componentType !== 'PPSS'">
      <h1 class="filter-title title">{{ "products.navs-idcw-heading" | translate }}</h1>
      <div class="d-flex align-items-center justify-content-between tabs-block">
        <ul class="nav nav-tabs" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" type="button" role="tab"
                    [class.active]="selectedComponentType === 'LatestNavs'"
                    (click)="onComponentTypeChange('LatestNavs')">{{ "products.nav-heading" | translate }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" type="button" role="tab" [class.active]="selectedComponentType === 'IDCW'"
                    (click)="onComponentTypeChange('IDCW')">{{ "products.idcw-heading" | translate }}
            </button>
          </li>
        </ul>
        <a *ngIf="showNav && accountsUrl" [href]="accountsUrl+navAlertsLink"
           class="btn btn-primary">{{ "products.nav-alerts" | translate }}</a>
      </div>
      <div id="header-top" class="hedaerTitle">
        <div class="filter-options mt-0 mb-4">
          <div class="form-group search-group" style="margin-right: 0;">
            <div>
              <input type="text" class="form-control search"
                     placeholder="{{ 'products.all-funds-search-funds-placeholder' | translate }}"
                     [(ngModel)]="searchTerm" (input)="searchFunds(searchTerm)">
              <div class="search-result" *ngIf="showFundSearchDropdown && searchTerm && searchTerm.length >= 3">
                <div class="inner">
                  <ng-container *ngFor="let fund of fundsForSearch">
                    <div class="funds-seach-title" (click)="showSelectedFund(fund)"
                         style="position: relative; z-index: 999999; cursor: pointer;">
                      <b>{{ fund?.fundName }}</b>
                      <span class="sub">{{ removeFundString(fund?.assetClass) }}</span>
                      <span class="sub">{{ removeFundString(fund?.invfocus) }}</span>
                      <span class="sub">{{ fund?.fundInceptionDate | yearsOld }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>

            </div>
            <div>
              <img alt="image" src="./assets/images/comparefund/closebutton.svg"
                   class="make-tag-for-all-page d-md-none share-icon2"
                   (click)="clearSearch()" style="position: relative;left: -485%;top: 7px;">
              <img alt="image" src="./assets/images/comparefund/closebutton.svg"
                   class="make-tag-for-all-page d-none d-md-block share-icon2"
                   (click)="clearSearch()" style="position: relative;left: 96%;top: -26px;">
            </div>
            <button class="btn btn-white toggle-filter d-inline-block d-lg-none"
                    (click)="toggleShowFilterBox()">
              <i class="bi bi-filter"></i><span *ngIf="forCount>0" class="items-num">{{ forCount }}</span>
              {{ "products.all-funds-filters-label" | translate }}
            </button>
          </div>

          <div class="dataFilter d-none d-md-block">
            <div class="d-flex align-items-center">
              <button class="btn btn-white" (click)="navigateCompareFunds()">
                <img alt="image" src="assets/images/fund/change-icon-sm.svg">
                {{ "products.fund-listing-button-compare" | translate }}<span
                  class="list-num">{{ compareListFundsCount }}</span></button>
              <button class="btn btn-white" (click)="navigateToWatchlist()">
                <i class="bi bi-bookmark"></i>
                {{ "products.all-funds-watchlist-btn" | translate }}<span
                  class="list-num">{{ watchListFundsCount }}</span></button>
            </div>
          </div>
          <div class="cardFilter mt-4 w-100 d-md-none">
            <div class="d-flex justify-content-start  gap-5 ">
              <div style="font-size: 0.813rem;" (click)="navigateCompareFunds()">
                <img alt="arrow down"
                  src="assets/images/fund/Vector1.svg"
                  class="fund-list-icon">  {{ "products.fund-listing-button-compare" | translate }}<span
                  class="icon-number">{{ compareListFundsCount }}</span></div>
              <div style="font-size: 0.813rem;" (click)="navigateToWatchlist()"><i
                  class="bi bi-bookmark fund-list-icon"></i> {{ "products.all-funds-watchlist-btn" | translate }}<span
                  class="icon-number">{{ watchListFundsCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>
    <div *ngIf="componentType === 'PPSS'">
      <nav aria-label="breadcrumb" class="breadcrumbfile" style="margin-left: 0;">
        <ol class="breadcrumb">
          <h1 class="filter-title" style="margin-left: 0;">{{ fundTitle }} ({{ fundListingData.length }})</h1>
        </ol>
      </nav>
    </div>
    <div class="row gx-3">
      <div class="col-lg-auto">
        <div class="fund-filter-block" [ngClass]="showAdvanceFilter ? 'position-relative' : ''">
          <h1 id="mutualfundsheader" class="filter-title title" *ngIf="componentType === 'PPSS'">{{ fundTitle }}
            ({{ fundListingData.length }})</h1>
          <div class="filters" [ngClass]="showFilterBox ? 'opened' : ''" id="filterHead">
            <div class="filter-container">
              <div class="content-box" id="header-top3">
                <div class="web-view-filter">
                  <div
                      class="filter-head d-none d-md-block text-center fontResize">{{ "products.ppss-filter-type-assetClass" | translate }}
                  </div>
                  <div class="d-md-none">
                    <div class="filter-selected-options mb-4" *ngIf="showSelected">
                      <span class="clear-filter d-none d-md-inline-block"
                            (click)="hideClear(selectedOptions)">{{ "products.all-funds-filters-reset-btn" | translate }}</span>
                      <div>
                        <span class="option d-md-none"
                              style="padding: 4px 10px; color: #3769FF; border: 1px solid #3769FF; background: #FFFFFF;"
                              *ngFor="let selectedOption of selectedOptions">
                          {{ selectedOption }} <i class="bi bi-x" (click)="removeOption(selectedOption)"></i>
                        </span>
                        <span class="clear-filter d-inline-block d-md-none"
                              (click)="hideClear(selectedOptions)">{{ "products.all-funds-filters-reset-btn" | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="inner-filters" id="innerfilter">
                    <div class="col-md-auto d-none d-md-block">
                      <div class="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <button class="nav-link fontResize" id="allFunds" data-bs-toggle="pill"
                                [ngClass]="!allfundsActive && pageTitle === '' ? 'active' : ''"
                                (click)="fundlistingFilter('All')"
                                data-bs-target="#v-pills-tab" type="button" role="tab"
                                aria-controls="v-pills-tab" aria-selected="false">All Funds
                        </button>
                        <ng-container *ngIf="!showMainList">
                          <button #filterButton class="nav-link fontResize" [id]="filterObj.id" data-bs-toggle="pill"
                                  *ngFor="let filterObj of mobileFilterChips; let j=index"
                                  [ngClass]="filterObj.label === pageTitle ? 'active':''"
                                  (click)="fundlistingFilter(filterObj.label)" data-bs-target="#v-pills-tab"
                                  type="button" role="tab"
                                  aria-controls="v-pills-tab" aria-selected="false">{{ filterObj.label }}
                          </button>
                        </ng-container>
                        <ng-container *ngIf="showMainList">
                          <button class="nav-link fontResize" data-bs-toggle="pill"
                                  *ngFor="let filterObj of mobileFilterChips; let j=index"
                                  data-bs-target="#v-pills-tab" type="button" role="tab"
                                  aria-controls="v-pills-tab">{{ filterObj.label }}
                          </button>
                        </ng-container>
                      </div>
                    </div>
                    <div class="filter-footer d-none d-lg-block bg-transparent text-center">
                      <button class="more-option-btn text-center fontResize"
                              (click)="toggleAdvanceFilter()"><span>More Filter</span>
                        <i class="bi bi-chevron-right"></i></button>
                    </div>
                    <div class="accordion d-md-none" id="filterAccordion" style="height:330px; overflow-y: auto;">
                      <div class="accordion-item"
                           *ngFor="let filterObj of (componentType !== 'PPSS' ? sidebarFilterList.slice(0,2) : sidebarFilterList); let j=index">
                        <h2 class="accordion-header" [id]="'filter'+filterObj.id">
                          <button class="accordion-button accordion-button-style" type="button"
                                  [ngClass]="{collapsed:j  !== 0}" [attr.aria-expanded]="j === 0?'true':'false'"
                                  data-bs-toggle="collapse" [attr.data-bs-target]="'#filtercollapse'+filterObj.id"
                                  [attr.aria-controls]="'filtercollapse'+filterObj.id">
                            {{ filterObj.filterLabel }}
                          </button>
                        </h2>
                        <div [id]="'filtercollapse'+filterObj.id" class="accordion-collapse collapse"
                             [ngClass]=" {show:j  === 0}"
                             [attr.aria-labelledby]="'filtercollapse'+filterObj.id" data-bs-parent="#filterAccordion">
                          <div class="accordion-body">
                            <ng-container *ngFor="let subAccordionObj of filterObj.filterItems;let i=index;">
                              <div class="form-check"
                                   *ngIf="!filterObj.expanded && filterObj.filterItems.length <8 ? i <7 : filterObj.expanded ?  i <= filterObj.filterItems.length : i<5">
                                <input class="form-check-input"
                                       type="{{filterObj.filterLabel === 'Annualised Returns'? 'radio' : 'checkbox'}}"
                                       value="{{subAccordionObj.label}}"
                                       id="{{subAccordionObj.label}}" name="flexRadioDefault"
                                       [checked]="subAccordionObj.selected"
                                       (click)="filterObj.showCustomReturn = true;getCheckboxValue($event,filterObj.filterLabel)">
                                <label class="form-check-label"
                                       for="{{filterObj.filterLabel === 'Annualised Returns'? 'flexRadioDefault1' : 'flexCheckIndeterminate'}}">
                                  {{ subAccordionObj.label }}
                                </label>
                              </div>
                            </ng-container>
                            <div class="form-group"
                                 *ngIf="filterObj.filterLabel === 'Annualised Returns' && filterObj.showCustomReturn">
                              <label class="d-block mb-2">Custom returns</label>
                              <div class="rang-slider-block">
                                <ngx-slider id="slider" [(value)]="highReturn" [options]="options1"
                                            (mouseup)="sliderEvent()"></ngx-slider>
                              </div>

                              <div
                                  class="d-flex align-items-center justify-content-between">
                                <span>{{ minReturn }}</span>
                                <span>{{ highReturn }}%</span>
                              </div>
                            </div>
                            <button *ngIf="filterObj.filterItems.length >7" class="more-option-btn toggle-btn"
                                    [ngClass]="filterObj.expanded ? '' : 'more'"
                                    (click)="filterObj.expanded = !filterObj.expanded"><i
                                class="bi bi-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                        <h2 class="accordion-header" id="headingOne">
                          <button class="accordion-button" type="button"
                                  data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                  aria-expanded="true" aria-controls="collapseOne">
                            Risk Level
                          </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show"
                             aria-labelledby="headingOne">
                          <div class="accordion-body">
                            <div class="form-group">

                              <div class="rang-slider-block">
                                <ngx-slider [(value)]="minRisk"
                                            [options]="optionst"></ngx-slider>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                        <h2 class="accordion-header" id="headingTwo">
                          <button class="accordion-button" type="button"
                                  data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                  aria-expanded="true" aria-controls="collapseTwo">
                            Fund Size
                          </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse show"
                             aria-labelledby="headingTwo">
                          <div class="accordion-body">
                            <div class="form-group">
                              <div class="rang-slider-block">
                                <ngx-slider [(value)]="minSize" [(highValue)]="highSize"
                                            [options]="options"></ngx-slider>
                              </div>

                              <div
                                  class="d-flex align-items-center justify-content-between">
                                <span class="forminmaxsize">{{ minSize }} Cr</span>
                                <span>{{ highSize }} Cr</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                        <h2 class="accordion-header" id="headingThree">
                          <button class="accordion-button" type="button"
                                  data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                  aria-expanded="true" aria-controls="collapseThree">
                            Fund Age
                          </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse show"
                             aria-labelledby="headingThree">
                          <div class="accordion-body">
                            <div class="form-group">
                              <div class="rang-slider-block">
                                <ngx-slider [(value)]="minAge"
                                            [(highValue)]="highAge"
                                            [options]="options1"></ngx-slider>
                              </div>

                              <div
                                  class="d-flex align-items-center justify-content-between">
                                <span class="forageminmax">{{ minAge }} years</span>
                                <span>{{ highAge }} years</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- advance filter block -->
                <div class="advanced-filter" *ngIf="showAdvanceFilter" style="z-index: 100001;">
                  <div class="filter-content">
                    <div class="inner-content">
                      <div class="d-flex justify-content-between fund-page-filter" style="background-color: #c2cee0;">
                        <h3 class="fontResize">More Filters</h3>
                      </div>
                      <div class="inner-filters" id="innerfilter">
                        <div class="accordion" id="filterAccordion">
                          <div class="accordion-item fontResize"
                               [ngClass]="filterObj.filterLabel === 'Asset Category'? 'd-none d-md-block' : ''"
                               *ngFor="let filterObj of (componentType !== 'PPSS' ? sidebarFilterList.slice(0,2) : sidebarFilterList); let j=index">
                            <h2 class="accordion-header" [id]="'filter'+filterObj.id">
                              <button class="accordion-button accordion-button-style" type="button"
                                      [ngClass]="{collapsed:j  !== 0}"
                                      [attr.aria-expanded]="j === 0?'true':'false'" data-bs-toggle="collapse"
                                      [attr.data-bs-target]="'#filtercollapses'+filterObj.id"
                                      [attr.aria-controls]="'filtercollapses'+filterObj.id">
                                {{ filterObj.filterLabel }}
                              </button>
                            </h2>
                            <div [id]="'filtercollapses'+filterObj.id" class="accordion-collapse collapse"
                                 [ngClass]=" {show:j  === 0}"
                                 [attr.aria-labelledby]="'filtercollapses'+filterObj.id"
                                 data-bs-parent="#filterAccordion">
                              <div class="accordion-body fontResize">
                                <ng-container *ngFor="let subAccordionObj of filterObj.filterItems;let i=index;">
                                  <div class="form-check fontResize"
                                       *ngIf="!filterObj.expanded && filterObj.filterItems.length <8 ? i <7 : filterObj.expanded ?  i <= filterObj.filterItems.length : i<5">
                                    <input class="form-check-input fontResize"
                                           type="{{filterObj.filterLabel === 'Annualised Returns'? 'radio' : 'checkbox'}}"
                                           value="{{subAccordionObj.label}}" id="{{subAccordionObj.label}}"
                                           name="flexRadioDefault"
                                           [checked]="subAccordionObj.selected"
                                           (click)="filterObj.showCustomReturn = true;getCheckboxValue($event,filterObj.filterLabel)">
                                    <label class="form-check-label"
                                           for="{{filterObj.filterLabel === 'Annualised Returns'? 'flexRadioDefault1' : 'flexCheckIndeterminate'}}">
                                      {{ subAccordionObj.label }}
                                    </label>
                                  </div>
                                </ng-container>
                                <div class="form-group fontResize"
                                     *ngIf="filterObj.filterLabel === 'Annualised Returns' && filterObj.showCustomReturn">
                                  <label class="d-block mb-2 fontResize">Custom returns</label>
                                  <div class="rang-slider-block fontResize">
                                    <ngx-slider id="slider" [(value)]="highReturn" [options]="options1"
                                                (mouseup)="sliderEvent()"></ngx-slider>
                                  </div>

                                  <div class="d-flex align-items-center justify-content-between fontResize">
                                    <span class="fontResize">{{ minReturn }}</span>
                                    <span class="fontResize">{{ highReturn }}%</span>
                                  </div>
                                </div>
                                <button *ngIf="filterObj.filterItems.length >7" class="more-option-btn toggle-btn"
                                        [ngClass]="filterObj.expanded ? '' : 'more'"
                                        (click)="filterObj.expanded = !filterObj.expanded"><i
                                    class="bi bi-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion accordion-flush" id="accordionFlushExample">
                          <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                            <h2 class="accordion-header" id="flush-headingOne">
                              <button class="accordion-button collapsed fontResize" type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseOne"
                                      aria-expanded="false" aria-controls="flush-collapseOne">
                                Risk Level
                              </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse"
                                 aria-labelledby="flush-headingOne"
                                 data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body">
                                <div class="form-group fontResize">
                                  <div class="rang-slider-block fontResize">
                                    <ngx-slider [(value)]="minRisk" (click)="changeFilter('Risk Level')"
                                                [options]="optionst"></ngx-slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                            <h2 class="accordion-header" id="flush-headingTwo">
                              <button class="accordion-button collapsed fontResize" type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseTwo"
                                      aria-expanded="false" aria-controls="flush-collapseTwo">
                                Fund Size
                              </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse"
                                 aria-labelledby="flush-headingTwo"
                                 data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body">
                                <div class="form-group">
                                  <div class="rang-slider-block fontResize">
                                    <ngx-slider [(value)]="minSize"
                                                [(highValue)]="highSize" (click)="changeFilter('Fund Size')"
                                                [options]="options">
                                    </ngx-slider>
                                  </div>

                                  <div
                                      class="d-flex align-items-center justify-content-between">
                                    <span class="forminmaxsize fontResize">{{ minSize }} Cr</span>
                                    <span class="fontResize">{{ highSize }} Cr</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item" *ngIf="componentType === 'PPSS'">
                            <h2 class="accordion-header" id="flush-headingThree">
                              <button class="accordion-button collapsed fontResize" type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseThree"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseThree">
                                Fund Age
                              </button>
                            </h2>
                            <div id="flush-collapseThree"
                                 class="accordion-collapse collapse"
                                 aria-labelledby="flush-headingThree"
                                 data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body">
                                <div class="form-group">
                                  <div class="rang-slider-block fontResize">
                                    <ngx-slider [(value)]="minAge"
                                                [(highValue)]="highAge" (click)="changeFilter('Fund Age')"
                                                [options]="options1"></ngx-slider>
                                  </div>

                                  <div
                                      class="d-flex align-items-center justify-content-between">
                                    <span class="forageminmax fontResize">{{ minAge }}
                                      years</span>
                                    <span class="fontResize">{{ highAge }} years</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="filter-footer d-none d-lg-flex">
                      <button class="btn btn-outline-primary forFooterFilterToggle fontResize"
                              (click)="toggleAdvanceFilter()">Cancel
                      </button>
                      <button class="btn btn-primary"
                              (click)="allFundsFilter()">Apply
                      </button>
                    </div>
                  </div>

                </div>
              </div>
              <div class="filter-footer d-flex d-lg-none">
                <button class="btn btn-outline-primary"
                        (click)="toggleShowFilterBox()">Cancel
                </button>
                <button class="btn btn-primary" (click)="mobileFilterBox()">Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Search Funds Section -->
      <div [ngClass]="componentType === 'PPSS'?'col-lg':'col-lg-9'"
           [ngStyle]="{'flex-grow':componentType !== 'PPSS'?'1':''}">
        <div class="hedaerTitle" [ngClass]="!isMobileView ? 'position-stiky' : ''" id="header-top"
             style="padding-top: 15px;">
          <div class="filter-options mt-0 mb-4" *ngIf="componentType === 'PPSS'">
            <div class="form-group" style="margin-right: 0;">
              <input type="text" class="form-control search"
                     placeholder="{{ 'products.all-funds-search-funds-placeholder' | translate }}"
                     [(ngModel)]="searchTerm" (input)="searchFunds(searchTerm)">
              <div class="search-result" *ngIf="showFundSearchDropdown && searchTerm && searchTerm.length >= 3">
                <div class="inner">
                  <ng-container *ngFor="let fund of fundsForSearch">
                    <div class="funds-seach-title" (click)="showSelectedFund(fund)"
                         style="position: relative; z-index: 999999; cursor: pointer;">
                      <b>{{ fund?.fundName }}</b>
                      <span class="sub">{{ removeFundString(fund?.assetClass) }}</span>
                      <span class="sub">{{ removeFundString(fund?.invfocus) }}</span>
                      <span class="sub">{{ fund?.fundInceptionDate | yearsOld }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
              <button class="btn btn-white toggle-filter d-inline-block d-lg-none"
                      (click)="toggleShowFilterBox()">
                <i class="bi bi-filter"></i><span *ngIf="forCount>0" class="items-num">{{ forCount }}</span>
                {{ "products.all-funds-filters-label" | translate }}
              </button>
            </div>
            <div>
              <img alt="image" src="./assets/images/comparefund/closebutton.svg"
                   class="make-tag-for-all-page share-icon2"
                   (click)="clearSearch()">
            </div>
            <div class="dataFilter">
              <div class="d-flex align-items-center">
                <span class="me-2" *ngIf="componentType === 'PPSS'">
                  {{ "products.all-funds-sort-by-btn" | translate }}</span>
                <div class="dropdown" *ngIf="componentType === 'PPSS'">
                  <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
                          aria-expanded="false">
                    {{ selectedSortItem.label }}
                  </button>
                  <ul class="dropdown-menu">
                    <ng-container *ngFor="let item of sortItemsArray">
                      <li style="cursor: pointer;" (click)="sortFunds(item)"
                          [class.selected-option]="item.id === selectedSortItem.id">
                        <a class="dropdown-item">{{ item.label }}</a>
                      </li>
                    </ng-container>

                  </ul>
                </div>
                <button class="btn btn-white" (click)="navigateCompareFunds()">
                  <img alt="image" class="share-icon2" src="assets/images/fund/change-icon-sm.svg">
                  {{ "products.fund-listing-button-compare" | translate }}<span
                    class="list-num">{{ compareListFundsCount }}</span></button>
                <button class="btn btn-white" (click)="navigateToWatchlist()">
                  <i class="bi bi-bookmark"></i>
                  {{ "products.all-funds-watchlist-btn" | translate }}<span
                    class="list-num">{{ watchListFundsCount }}</span></button>
              </div>
            </div>
            <div class="cardFilter mt-2 w-100">
              <div class="d-flex justify-content-between align-items-center ">
                <div type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottomNew"
                     aria-controls="offcanvasBottomNew" style="font-size: 0.813rem;" *ngIf="componentType === 'PPSS'">
                  {{ "products.all-funds-sort-by-btn" | translate }}&nbsp;
                  <img alt="image" src="assets/images/fund/Vector.svg"></div>
                <div style="font-size: 0.813rem;" (click)="navigateCompareFunds()">
                  <img alt="compare"
                    src="assets/images/fund/Vector1.svg"
                    class="fund-list-icon">{{ "products.fund-listing-button-compare" | translate }}<span
                    class="list-num icon-number">{{ compareListFundsCount }}</span>
                </div>
                <div style="font-size: 0.813rem;" (click)="navigateToWatchlist()">
                  <i class="bi bi-bookmark fund-list-icon"></i>{{ "products.all-funds-watchlist-btn" | translate }}<span
                    class="list-num icon-number">{{ watchListFundsCount }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-md-none">
            <div class="filter-selected-options" style="display: contents;">
              <span class="option d-md-none preData" style="padding: 4px 12px; font-size: 0.75rem;;"
                    [ngClass]="{'selected-option1': isOptionSelected(preseletedOption.label)}"
                    *ngFor="let preseletedOption of mobileFilterChips"
                    (click)="toggleOptionSelection(preseletedOption.label)">
                {{ preseletedOption.label }}
              </span>
            </div>
          </div>
          <div class="filter-selected-options" *ngIf="showSelected">
            <span class="clear-filter d-none d-md-inline-block" (click)="hideClear(selectedOptions)">
              {{ "products.all-funds-filters-reset-btn" | translate }}</span>
            <div class="d-flex" style="flex-wrap:wrap;">
              <span class="option d-none d-md-block" *ngFor="let selectedOption of selectedOptions">
                {{ selectedOption }} <i class="bi bi-x" style="cursor: pointer;"
                                        (click)="removeOption(selectedOption)"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="funds-container" [ngClass]="componentType === 'PPSS'?'cust-ppss':'cust-nav'" id="scroll-bar" style="padding-top: 4px;"
             *ngIf="fundListingData.length; else fundListingEmpty">
          <ng-container *ngFor='let fund of fundListingData; let i = index'>
            <div class="fund-card-wrapper">
              <ft-home-fund-card [brConfiguration]="brConfiguration" [fund]="fund" [investmentCartAddForm]="true"
                                 [hasThreeDotOptions]="true"></ft-home-fund-card>
            </div>
          </ng-container>
        </div>
        <ng-template #fundListingEmpty>
          <div class="text-center mt-5 text-big">{{ "products.fund-listing-no-listing-data" | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>

  <ng-template #loaderBlock>
    <div class="text-center mb-5 mt-5">
      <div id="loader">
        <img src="assets/images/home/loader.gif" alt="Loading...">
      </div>
    </div>
  </ng-template>
</section>

<!-- Mobile Sorting Options -->
<div class="offcanvas offcanvas-bottom sort-bottom" tabindex="-1" id="offcanvasBottomNew"
     aria-labelledby="offcanvasBottomLabel" #offcanvasBottomNew
     style="height: 55%; border-top-left-radius: 39px; border-top-right-radius: 39px;">
  <div class="offcanvas-header">
    <div class="line"></div>
  </div>
  <div class="offcanvas-body small">
    <div class="Popularity mb-4">
      <div class="mb-4">
        <h4 class="mb-2" style="font-weight: 600;">{{ "products.all-funds-sort-by-btn" | translate }}</h4>
      </div>
      <ng-container *ngFor="let item of sortItemsArray">
        <div>
          <h4 style="font-size: 0.938rem;
                font-weight: 600;
                margin-top: 10px;">{{ item.mobileTitle }}</h4>
          <div class="d-flex gap-3">
            <div class="form-check radioModule">
              <input class="form-check-input" type="radio" [value]="item.id"
                     (change)="changeItem(item)" name="flexRadioDefault" id="{{ item.id }}">
              <label class="form-check-label" style="font-size: 0.938rem;" [for]="item.id">
                {{ item.mobileLabel }}
              </label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div style="height: 100px; width: 100%;">
    <div class="d-flex justify-content-center align-items-center gap-3" style="height: 100%; padding: 0 14px;">
      <button class="btn btn-outline-primary" style="width: 233px; height: 50px; font-size: 1.25rem; font-weight: 600;"
              (click)="removeOffCanvasOverflow()"
              data-bs-dismiss="offcanvas" aria-label="Close">{{ "products.all-funds-cancel-btn" | translate }}
      </button>
      <button class="btn btn-primary" (click)="applyFiter()" data-bs-dismiss="offcanvas" aria-label="Close"
              style="width: 233px; height: 50px; font-size: 1.25rem; font-weight: 600;">
        {{ "products.all-funds-apply-btn" | translate }}
      </button>
    </div>
  </div>
</div>
